var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoAiProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 26.734c0-4.504 3.694-8.156 8.25-8.156H22c.76 0 1.375-.608 1.375-1.36 0-.75-.616-1.359-1.375-1.359h-9.625c-6.075 0-11 4.87-11 10.875v19.032c0 6.006 4.925 10.875 11 10.875h19.25c6.075 0 11-4.87 11-10.875V36.25c0-.75-.616-1.36-1.375-1.36-.76 0-1.375.61-1.375 1.36v9.516c0 4.504-3.694 8.156-8.25 8.156h-19.25c-4.556 0-8.25-3.652-8.25-8.156V26.734z",
    fill: "#B8EF36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.947 26.625c-2.732-1.913-6.51.018-6.51 3.327v12.595c0 3.31 3.778 5.24 6.51 3.328l8.992-6.297a4.051 4.051 0 000-6.656l-8.992-6.297zm-3.76 3.327c0-1.103 1.26-1.747 2.17-1.109l8.993 6.297a1.35 1.35 0 010 2.219l-8.993 6.297c-.91.638-2.17-.006-2.17-1.11V29.953z",
    fill: "#B8EF36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 18.125l9.6 2.11 2.133 9.49 2.134-9.49 9.6-2.11-9.6-2.109-2.134-9.49-2.133 9.49-9.6 2.11zM32.564 10.74l-1.086-4.297-4.345-1.073 4.345-1.074L32.564 0l1.086 4.296 4.345 1.074-4.345 1.073-1.086 4.296z",
    fill: "#B8EF36"
  })));
}
export default SvgVideoAiProcessing;